import { dcpcApi } from './dcpcApi';
import { tags } from './tags';

const {
  PHENOMENON_TYPES_TAG,
} = tags;

dcpcApi.enhanceEndpoints({ addTagTypes: [PHENOMENON_TYPES_TAG] });
const observationTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhenomenonTypes: builder.query({
      query: () => 'phenomenon-types',
      providesTags: [PHENOMENON_TYPES_TAG],
    }),
  }),
});

export const {
  useGetPhenomenonTypesQuery,
} = observationTypesApi;
